/**
 * Landing Feature - React Hooks
 * Hooks for landing page functionality
 */

import { useMutation } from "@tanstack/react-query";
import { landingRepository } from "../../data/repositories";
import { createLandingUseCases } from "../usecases";
import type { ContactFormData, MailingListSubscription } from "../entities";

// Initialize use cases with repository
const useCases = createLandingUseCases(landingRepository);

/**
 * Hook to submit contact form
 */
export const useSubmitContactForm = () => {
  return useMutation({
    mutationFn: (data: ContactFormData) => useCases.submitContactForm(data),
  });
};

/**
 * Hook to subscribe to mailing list
 */
export const useSubscribeToMailingList = () => {
  return useMutation({
    mutationFn: (data: MailingListSubscription) =>
      useCases.subscribeToMailingList(data),
  });
};

/**
 * Export validation utilities
 */
export const landingValidation = {
  isEmailValid: useCases.isEmailValid,
  isNameValid: useCases.isNameValid,
};
